<!--
 * @Author       : 萝卜兄台
 * @Date         : 2023-03-30 14:53:08
 * @LastEditors  : 萝卜兄台\thund leili995997651@qq.com
 * @LastEditTime : 2023-04-11 14:16:04
 * @FilePath     : \vue3-ts-mm\src\components\AppLocalePicker\index.vue
 * @Description  : 这是描述
-->
<template>
  <div class="appLocale">
    <a-dropdown>
      <global-outlined />
      <template #overlay>
        <a-menu v-model:selectedKeys="current" @click="handleClick">
          <a-menu-item key="en_US">
            <div class="appLocaleList">
              <span>us</span>
              English
            </div>
          </a-menu-item>
          <a-menu-item key="tr_TR">
            <div class="appLocaleList">
              <span>tr</span>
              Türkçe
            </div>
          </a-menu-item>

          <a-menu-item key="zh_CN">
            <div class="appLocaleList">
              <span>cn</span>
              简体中文
            </div>
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount, ref, nextTick } from 'vue'
import { GlobalOutlined } from '@ant-design/icons-vue'
import { useI18n } from 'vue-i18n'

import { globalStore } from '@/store/global'
const store: any = globalStore()
const { locale, t } = useI18n()

const current = ref<string[]>(['zh_CN'])

onBeforeMount(() => {
  let lang = localStorage.getItem('lang')
  if (!lang) {
    lang = 'zh_CN'
    localStorage.setItem('lang', 'zh_CN')
  }
  store.lang = lang
  locale.value = lang
  current.value = [lang]
  document.title = `${t('login.title')}`
})

const handleClick = (e: any) => {
  current.value = [e.key]
  store.lang = e.key
  locale.value = e.key
  localStorage.setItem('lang', e.key)
  store.isRouterAlive = false
  document.title = `${t('login.title')}`

  nextTick(() => {
    store.isRouterAlive = true
  })
}
</script>

<style lang="less">
@import url('./index.less');
</style>
